export default "__VITE_ASSET__7dbc45a6__"